
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "Navigation",
  components: {},
})
export default class Navigation extends Vue {
  navTabs = [
    {
      label: "首页",
      children: [
        "/temp/home",
        "/pcm/home",
        "/pcm/homePage",
        "/pcm/company",
        "/pcm/allpolicy",
        "/detail/match",
        "/pcm/tax",
        "/pcm/verify",
        "/pcm/productSale",
        "/pcm/expendpolicy_a",
        "/pcm/expendpolicy_b",
        "/pcm/expendpolicy_c",
        "/pcm/expendpolicy_d",
        "/pcm/expendpolicy_e",
        "/pcm/expendpolicy_f",
        "/pcm/GHpolicy_a",
        "/pcm/GHpolicy_b",
        // '/pcm/company/detail',
        // '/pcm/keyword/detail',
      ],
      default: "/pcm/homePage",
      index: 0,
    },
    {
      label: "政策库",
      children: ["/pcm/policy", "/detail/policy"],
      default: "/pcm/policy",
      index: 1,
    },
    {
      label: "政策办理",
      children: ["/pcm/apply", "/detail/apply", "/detail/declare"],
      default: "/pcm/apply",
      index: 2,
    },
    {
      label: "政策大讲堂",
      children: ["/pcm/media", "/detail/img", "/detail/text"],
      default: "/pcm/media",
      index: 3,
    },
    {
      label: "无申请兑现",
      children: [
        "/pcm/noApply",
        "/detail/noApply",
        // '/pcm/keyword/detail',
      ],
      default: "/pcm/noApply",
      index: 4,
    },
    // {
    //   label: "申报通知",
    //   children: ["/pcm/inform", "/detail/inform"],
    //   default: "/pcm/inform",
    //   index: 3,
    // },

    {
      label: "公示公告",
      children: ["/pcm/publicy", "/detail/publicy"],
      default: "/pcm/publicy",
      index: 5,
    },
    {
      label: "咨询建议",
      children: ["/pcm/appeal"],
      default: "/pcm/appeal",
      index: 6,
    },
    /* {
        label: "企业诉求",
        children: ["/pcm/appeal"],
        default: "/pcm/appeal",
        index: 6,
      },
      {
        label: "服务超市",
        children: ["/pcm/market", "/detail/market"],
        default: "/pcm/market",
        index: 7,
      },*/

    // {
    //   label: '政策清单',
    //   children: ["/pcm/list"],
    //   default: '/pcm/list',
    //   index: 7,
    // },
  ];
  activeName = "";
  handleClick(e: any) {
    const activeName = Number(e.$el.id.replace("pane-page", ""));
    const currenName = this.$route.name;
    this.$router.push({ path: this.navTabs[activeName].default });
  }
  created() {
    this.fixTab();
  }
  fixTab() {
    const currentRouter = this.$route.path;
    const currentActive = this.navTabs.find(
      (item: any) =>
        item.children.includes(currentRouter) ||
        item.children.some((route: any) => currentRouter.indexOf(route) !== -1)
    );
    this.activeName = `page${currentActive?.index}`;
  }
  @Watch(`$route`)
  routechange(to: any, from: any) {
    this.fixTab();
  }
}
